// 页面内共享的小工具
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

// today 模式的固定起始日（后端 UTC 零点）按 UTC 日历日渲染，否则西半球会倒退一天
export const formatTodayStartDate = (d: string): string => dayjs.utc(d).format('MMM D, YYYY');

// 账单地址一行摘要（原型 billingAddressSummary）："1234 Market St, Suite 200, San Francisco, CA 941032612"
export const billingAddressSummary = (address?: Record<string, any>): string => {
    const a = address || {};
    const head = [a.address1, a.address2, a.city].filter(Boolean).join(', ');
    const tail = [a.state, a.postalCode].filter(Boolean).join(' ');
    return [head, tail].filter(Boolean).join(', ') || 'your billing address';
};

// 通用地址一行摘要（review 展示用，空地址返回 ''）
export const addressSummary = (o?: Record<string, any>): string => {
    if (!o?.address1) return '';
    const head = [o.address1, o.address2, o.city].filter(Boolean).join(', ');
    const tail = [o.state, o.postalCode].filter(Boolean).join(' ');
    return [head, tail].filter(Boolean).join(', ');
};

// NPI 口径：可以不填，但填了就必须在 NPI Registry 查到。
// 未通过 = 不足 10 位 / 查询中（npiChecking，NpiRegistryBox 防抖开始即置位）/
// 无查询结果（如 hydrate 后从未触发查询）/ 查不到（notfound）。
// Continue 硬拦截与 Review 校验（reviewSpec INVALID）共用此口径
export const npiUnverified = (slot?: Record<string, any>): boolean => {
    const digits = String(slot?.npi ?? '').replace(/\D/g, '');
    if (!digits) return false;
    if (digits.length !== 10) return true;
    return !!slot?.npiChecking || !slot?.npiType || slot.npiType === 'notfound';
};

// 手填 taxonomy（My taxonomy is not listed here）的格式：3 位数字 + 6 位字母或数字 + X，共 10 位（NUCC）
export const TAXONOMY_CODE_RE = /^[0-9]{3}[0-9A-Z]{6}X$/;

// 手填 taxonomy 格式不对：Review 视为未填写，拦截提交
export const taxonomyManualInvalid = (slot?: Record<string, any>): boolean =>
    !!slot?.taxManual && !!slot?.taxonomy && !TAXONOMY_CODE_RE.test(slot.taxonomy);

// 原型 taxDiffers：手填且不在该槽位的 NPPES 列表里 → Differs from NPPES（Ops 在首个 claim 前核对）
export const taxonomyDiffersFromNppes = (slot?: Record<string, any>): boolean =>
    !!slot?.taxManual &&
    !!slot?.taxonomy &&
    !(slot.taxonomyOptions || []).some((t: { code: string }) => t.code === slot.taxonomy);
